
































































































import Vue from 'vue';
import { Watch, Component } from 'vue-property-decorator';

@Component({
	name: 'form-timeout',
	props: {
		showIdleTimeoutWarningDialogToggle: Boolean,
	},
})
export default class FormTimeoutModal extends Vue {
	// TODO(CARD-108): How to make const?  113:8 A class member cannot have the 'const' keyword.
	circumference = 283;
	// 3 * 60
	timeOfVisibleCountdown = 180;

	showDialog = false;
	timeout = 0;
	timeElapsed = 0;
	timeInterval = 0;

	@Watch('$props.showIdleTimeoutWarningDialogToggle')
	showDialogUpdated() {
		this.showDialog = true;
		this.startAlertInterval();
	}

	// Start the visible countdown.
	startAlertInterval() {
		this.timeElapsed = 0;
		this.timeInterval = window.setInterval(() => this.onInterval(), 1000);
	}

	quit() {
		this.showDialog = false;
		window.clearInterval(this.timeInterval);
		if (this.$router.currentRoute.path != '/') {
			this.$router.push('/');
		}
		this.$emit('quit');
	}

	get formattedTimeLeft() {
		const timeRemaining = this.countDown();
		const minutes = Math.floor(timeRemaining / 60);
		const seconds = timeRemaining % 60;
		let secondsString = `${seconds}`;
		if (seconds != null && seconds < 10) {
			secondsString = `0${seconds}`;
		}
		return `${minutes}:${secondsString}`;
	}

	get timerAnimation() {
		return this.circleDashArray(this.arrayInterval());
	}

	circleDashArray(interval: number) {
		return `${Math.max(0, interval * this.circumference)} 283`;
	}

	arrayInterval() {
		const baseInterval = this.countDown() / this.timeOfVisibleCountdown;
		return (
			baseInterval - (1 / this.timeOfVisibleCountdown) * (1 - baseInterval)
		);
	}

	countDown() {
		return this.timeOfVisibleCountdown - this.timeElapsed;
	}

	// Event handlers

	onTimeout() {
		window.clearTimeout(this.timeout);
		this.showDialog = true;
		this.startAlertInterval();
	}

	onQuitClick() {
		this.quit();
	}

	onContinueClick() {
		this.showDialog = false;
		window.clearInterval(this.timeInterval);
	}

	onInterval() {
		this.timeElapsed++;
		const timeLeft = this.countDown();
		if (timeLeft <= 0) {
			this.quit();
		} 
	}
}
